var Curriculog = Curriculog || {};

Curriculog.RoleListView = (function ($, _, Backbone, RoleListView) {

	RoleListView = Curriculog.ItemListView.extend({
		template: 'HierarchyList/roleList.html',

		initialize: function (options) {
			this.entityRoleCanDeletes = options.entityRoleCanDeletes;
			this.items = options.items;
      this.params = options.params;
			this.render();
		},

		render: function () {
			templateVars = {
				items: this.items,
				entityRoleCanDeletes: this.entityRoleCanDeletes,
        cui_enabled: this.params.cui_enabled
			}
			var el = nunjucks.render(this.template, templateVars);
			this.replaceElement(el);
		},

	});
	return RoleListView;

})($, _, Backbone, Curriculog.RoleListView || {});
